// 富信组件
import { get, post,postJson } from './axios'
// 获取用户菜单列表
export const getSeller = p => get(`/seller/current`, p);